import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/logo/logo.svg'
import _imports_1 from '@/assets/images/icons/abc.png'
import _imports_2 from '@/assets/images/icons/light.png'
import _imports_3 from '@/assets/images/illustrations/not_found.png'


const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded-md" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "luca-logo",
    height: "24",
    width: "35"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 text-neutral-600 text-sm" }, " Bạn hãy ấn nút “DẠY MT” để chuyển mục tiêu vào Kế hoạch hiện tại ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z",
    fill: "#E5A42B"
  })
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "mt-10" }
const _hoisted_10 = { class: "p-6 bg-white shadow-sm rounded-2xl mb-10" }
const _hoisted_11 = { class: "flex items-center justify-between mb-8" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-600" }, " Thống kê Mục tiêu tạm dừng ", -1)
const _hoisted_13 = {
  key: 0,
  type: "button",
  class: "button-p text-center bg-none shadow-none flex items-center justify-center btn--text w-fit"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-2",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.4702 6.65087L13.7102 5.41084C13.8461 5.27498 13.914 5.20705 13.9667 5.14509C14.6009 4.39841 14.6009 3.30223 13.9667 2.55555C13.914 2.49359 13.8461 2.42566 13.7102 2.2898C13.5744 2.15394 13.5064 2.08601 13.4445 2.03338C12.6978 1.39915 11.6016 1.39915 10.855 2.03338C10.793 2.086 10.7251 2.15391 10.5893 2.2897L10.5892 2.28978L10.5892 2.2898L9.33099 3.54801C10.0747 4.84221 11.1583 5.91748 12.4702 6.65087ZM7.87633 5.00267L2.86273 10.0163C2.43767 10.4413 2.22514 10.6539 2.0854 10.915C1.94567 11.1761 1.88672 11.4708 1.76883 12.0602L1.37318 14.0385C1.30666 14.3711 1.27339 14.5374 1.368 14.632C1.46261 14.7266 1.62892 14.6934 1.96153 14.6269L3.9398 14.2312L3.93982 14.2312L3.93984 14.2312C4.52927 14.1133 4.82399 14.0544 5.08508 13.9146C5.34617 13.7749 5.55869 13.5624 5.98373 13.1373L5.98376 13.1373L5.98377 13.1373L11.0118 8.10931C9.75111 7.3111 8.68202 6.24922 7.87633 5.00267Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_15 = { class: "flex flex-nowrap w-full md-down:flex-col" }
const _hoisted_16 = { class: "p-6 border rounded-l-lg border-neutral-200 w-full md-down:rounded-t md-down:rounded-b-none md:border-r-0 md-down:border-b-0" }
const _hoisted_17 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số lĩnh vực ")
], -1)
const _hoisted_20 = { class: "p-6 border rounded-r-lg border-neutral-200 w-full md-down:rounded-b md-down:rounded-t-none" }
const _hoisted_21 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số mục tiêu")
], -1)
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "font-semibold text-lg text-neutral-600 mb-4" }
const _hoisted_26 = { class: "shadow-sm sm:rounded-2xl overflow-hidden" }
const _hoisted_27 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_28 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_29 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      style: {"min-width":"160px"}
    }, " Nội dung "),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_31 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_32 = { class: "ml-2" }
const _hoisted_33 = { class: "px-6 py-4 text-neutral-700 w-full" }
const _hoisted_34 = { class: "flex items-center" }
const _hoisted_35 = { class: "mr-2 hover:text-yellow-700 hover:underline" }
const _hoisted_36 = {
  key: 0,
  class: "flex gap-2 flex-wrap",
  style: {"max-width":"360px"}
}
const _hoisted_37 = {
  key: 0,
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-neutral-200 text-neutral-700 h-fit w-fit whitespace-nowrap font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_38 = {
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-pink-100 whitespace-nowrap text-neutral-700 h-fit w-fit font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-4",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.212 6.21209C11.5782 5.84597 12.1717 5.84597 12.5379 6.21209C12.8995 6.57371 12.9039 7.15727 12.5512 7.52434L7.56092 13.7622C7.55371 13.7712 7.54602 13.7798 7.53787 13.7879C7.17175 14.154 6.57816 14.154 6.21204 13.7879L2.90398 10.4799C2.53787 10.1137 2.53787 9.52015 2.90398 9.15403C3.2701 8.78791 3.86369 8.78791 4.22981 9.15403L6.84671 11.7709L11.1872 6.24013C11.1949 6.23029 11.2032 6.22093 11.212 6.21209Z",
    fill: "#2AA797"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10.0615 12.6374L11.212 13.7879C11.5782 14.154 12.1718 14.154 12.5379 13.7879C12.546 13.7798 12.5537 13.7712 12.5609 13.7622L17.5512 7.52434C17.9039 7.15727 17.8995 6.57371 17.5379 6.21209C17.1717 5.84597 16.5782 5.84597 16.212 6.21209C16.2032 6.22093 16.1949 6.23029 16.1872 6.24013L11.8467 11.7709L11.24 11.1642L10.0615 12.6374Z",
    fill: "#2AA797"
  })
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "text-green-600" }, " THÊM VÀO KH ", -1)
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center flex-col"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  height: "250",
  width: "250"
}, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-600 text-center text-lg" }, " Lớp nhóm chưa có mục tiêu tạm dừng ", -1)
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TooltipGoalDetail = _resolveComponent("TooltipGoalDetail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.alertShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", {
                class: "top-1 right-2 absolute cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.alertShow = false))
              }, _hoisted_8)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            false
              ? (_openBlock(), _createElementBlock("button", _hoisted_13, [
                  _hoisted_14,
                  _createTextVNode(" Chỉnh sửa ")
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createTextVNode(" " + _toDisplayString(_ctx.skill_count), 1)
            ]),
            _hoisted_19
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createTextVNode(" " + _toDisplayString(_ctx.goal_count), 1)
            ]),
            _hoisted_23
          ])
        ])
      ]),
      (_ctx.goals && _ctx.goals.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goals, (goal, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "mb-10",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_25, _toDisplayString(index + 1) + ". " + _toDisplayString(goal.skill.name), 1),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("table", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goal.goals, (g, i) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: g.goal_id,
                                class: _normalizeClass([
													i % 2 === 0
														? 'bg-white'
														: 'bg-neutral-50'
												, "text-neutral-700"])
                              }, [
                                _createElementVNode("td", _hoisted_31, [
                                  _createElementVNode("div", _hoisted_32, _toDisplayString(i + 1), 1)
                                ]),
                                _createElementVNode("td", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, [
                                    _createVNode(_component_router_link, {
                                      to: `/group-class/${_ctx.id}/${g.goal_id}`
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_35, _toDisplayString(g.goal_name ||
																	g.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]),
                                    _createVNode(_component_TooltipGoalDetail, {
                                      "is-group": true,
                                      "goal-id": 
																g.goal_id ||
																g.id
															,
                                      "student-id": _ctx.id
                                    }, null, 8, ["goal-id", "student-id"])
                                  ]),
                                  (
															(g?.assistance_levels &&
																_ctx.org.enable_goal_assistance_level) ||
															g?.display_source
														)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                        (g?.display_source)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(g?.display_source), 1))
                                          : _createCommentVNode("", true),
                                        (
																g?.assistance_levels &&
																_ctx.org.enable_goal_assistance_level
															)
                                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(g?.assistance_levels, (ass) => {
                                              return (_openBlock(), _createElementBlock("div", { key: ass }, [
                                                _createElementVNode("div", _hoisted_38, _toDisplayString(ass), 1)
                                              ]))
                                            }), 128))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", null, [
                                  (
															_ctx.goal_added.includes(
																g.goal_id
															)
														)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "button-p btn--text whitespace-nowrap w-40 text-green-600",
                                        onClick: ($event: any) => (
															_ctx.doGoal(g.goal_id)
														)
                                      }, _hoisted_42, 8, _hoisted_39))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: "button-p btn--text whitespace-nowrap w-56",
                                        onClick: ($event: any) => (
															_ctx.doGoal(g.goal_id)
														)
                                      }, " Dạy MT ", 8, _hoisted_43))
                                ])
                              ], 2))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_47))
    ])
  ]))
}